import {
  GET_POLL_FETCH_DATA_SUCCESS,
  GET_POLL_HAVE_ERROR,
  GET_POLL_ARE_LOADING,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Get } from "../../services/api.service";

// Action creator function to handle different types of home primary actions
export function getPollAction(action, payload) {
  switch (action) {
    case GET_POLL_HAVE_ERROR:
      return {
        type: action,
        hasError: payload,
      };

    case GET_POLL_ARE_LOADING:
      return {
        type: action,
        isLoading: payload,
      };

    case GET_POLL_FETCH_DATA_SUCCESS:
      return {
        type: action,
        homePrimary: payload,
      };

    default:
      return;
  }
}

// Async action creator function to fetch home primary data
export function getPollFetchData() {
  return (dispatch) => {
    try {
      // Dispatch action indicating data is loading
      dispatch(getPollAction(GET_POLL_ARE_LOADING, true));

      // Check if home primary data is available in local storage
      if (localStorage.getItem("SandeshHome")) {
        // If available, dispatch action with data from local storage
        dispatch(
          getPollAction(
            GET_POLL_FETCH_DATA_SUCCESS,
            JSON.parse(localStorage.getItem("SandeshHome")),
          ),
        );
      }

      // Fetch home primary data using GET request
      return new Promise((resolve, reject) => {
        Get(HttpService.getPoll).then(
          (result) => {
            // Store fetched data in local storage
            localStorage.setItem("SandeshHome", JSON.stringify(result.data));
            // Dispatch action with fetched home primary data
            dispatch(getPollAction(GET_POLL_FETCH_DATA_SUCCESS, result.data));
            resolve(result?.data);
          },
          (error) => {
            reject(error); // Reject promise with error if fetching fails
          },
        );
      });
    } catch (error) {
      // Dispatch action if there's an error in fetching data
      dispatch(getPollAction(GET_POLL_HAVE_ERROR, true));
    }
  };
}
